export default "__VITE_ASSET__2549c345__"